import { TTakerGoSettings } from '../types/takerGo';
import { ORDER_STATUS } from '~/constants/order';

export const defaultTakerGoSetting: TTakerGoSettings = {
  orderStatus: ORDER_STATUS.ACCEPTED,
  yallowApiKey: '',
  takerFleetApiKey: '',
};
